// Page: progress-bar  (shared by progress-bar.module + progress-bar-il.module)
//
// Consolidates two near-identical inline scripts that differed only in which
// pathnames light up the first two steps:
//   progress-bar.module     → /my-usage, /myusage, /my_usage, /my-usage-lh
//   progress-bar-il.module  → /il-usage
// Both then marked `.progress-bar-item-1` and `.progress-bar-item-2` active.
//
// The variant axis is now data-driven via data-ea-config:
//   { "activateOnPaths": [...], "steps": 2 }
// so a single page file serves both modules.
//
// DELIBERATE CHANGE (behaviour-preserving): the step lookups are scoped to `root`
// (were document.getElementsByClassName[0]).

interface ProgressBarConfig {
  activateOnPaths?: string[]
  steps?: number
}

export function init(root: HTMLElement, config: unknown): void {
__ea_trace("modules/shared/progress-bar.ts","init",[root,config],["root","config"]);
  const { activateOnPaths = [], steps = 0 } = (config ?? {}) as ProgressBarConfig
  if (activateOnPaths.indexOf(window.location.pathname) === -1) return
  for (let i = 1; i <= steps; i++) {
    root.querySelector(`.progress-bar-item-${i}`)?.classList.add("active")
  }
}
